import { WorkflowQuestionConfig } from '../workflowQuestionConfig';
import { WorkflowResponseState } from '../workflowResponseState';
import { QuestionExceptionConfig } from './questionException';

export enum TimeType {
  StartEndTimes = 'START_END_TIMES',
  TimeOnly = 'TIME_ONLY',
  DateOnly = 'DATE_ONLY',
  TimeAndDate = 'TIME_AND_DATE',
}
export interface TimeQuestionConfig
  extends WorkflowQuestionConfig,
    TimeQuestionConfigBase,
    QuestionExceptionConfig {}

export interface TimeResponseState
  extends WorkflowResponseState,
    TimeQuestionConfigBase {}

interface TimeQuestionConfigBase {
  timeType: TimeType;
  timeTypeValue?: string | StartEndTimes | DateAndTime;
}

export interface StartEndTimes {
  startTime: string;
  endTime: string;
}

// Value shape for the TimeAndDate variation: a user-chosen date (MM/DD/YYYY)
// paired with a time (ISO string, same as TimeOnly stores).
export interface DateAndTime {
  date: string;
  time: string;
}
